import { render, staticRenderFns } from "./c_card.vue?vue&type=template&id=535601a3&scoped=true&"
import script from "./c_card.vue?vue&type=script&lang=js&"
export * from "./c_card.vue?vue&type=script&lang=js&"
import style0 from "./c_card.vue?vue&type=style&index=0&id=535601a3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535601a3",
  null
  
)

export default component.exports